// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 873) return "static/chunks/873-c24d3e25bc70359e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"675":"9cac81bc","708":"c72a76bf","976":"b3fd6d3f"}[chunkId] || chunkId) + "." + {"467":"6e18fd5a1e53ff8f","587":"e07b7a8bf38739be","675":"3de4d7fdbb8ed956","708":"74a378ee4db23884","968":"e9e9ab7a4714b524","976":"a13460e0e2b14868"}[chunkId] + ".js";
};